/**
 * Actualiza las velocidades del viento para todas las estaciones meteorológicas
 * 
 * @param {ol.source.Vector} stations - Fuente de datos que contiene todas las estaciones 
 * meteorológicas cargadas del GeoJSON. Es la fuente de datos original donde se almacenan 
 * las características (features) individuales de cada estación.
 * 
 * @param {ol.source.Cluster} clusterSource - Fuente que agrupa las estaciones que están 
 * cerca entre sí. Se usa para visualizar grupos de estaciones cuando el zoom está alejado. 
 * Cuando actualizamos los datos de viento, necesitamos refrescar este source para que los 
 * cambios se reflejen en la visualización.
 * 
 */
export function updateWindSpeeds(stations, clusterSource) {
    const features = stations.getFeatures();
    if (features.length === 0) {
        console.log('Estado: No hay estaciones cargadas');
        return;
    }
    
    features.forEach(feature => {
        const newWindSpeed = Math.floor(Math.random() * 130);
        feature.set('windSpeed', newWindSpeed);
    });
    
    clusterSource.refresh();
} 